export default __webpack_public_path__ + "static/AseoInd_3-7ec3001410cde6179b7cae9f189f854e.png";